import {
  GET_DESKTOP_ACTIVITY_REQUESTED,
  GET_DESKTOP_ACTIVITY_SUCCESS,
  GET_DESKTOP_ACTIVITY_FAILURE,
  GET_DESKTOP_EVENTS_REQUESTED,
  GET_DESKTOP_EVENTS_SUCCESS,
  GET_DESKTOP_EVENTS_FAILURE,
} from './desktop.constants'
import API from './desktop.api'

export const getDesktopActivity = (contactId, isRootRecording) => {
  return async dispatch => {
    dispatch(getDesktopActivityRequested())
    try {
      const desktopActivity = await API.getDesktopActivity(contactId, isRootRecording)
      dispatch(getDesktopActivitySuccess(desktopActivity))
    } catch (error) {
      dispatch(getDesktopActivityFailure(error))
    }
  }
}

export const getDesktopActivityRequested = () => ({
  type: GET_DESKTOP_ACTIVITY_REQUESTED,
})

export const getDesktopActivitySuccess = data => ({
  data,
  type: GET_DESKTOP_ACTIVITY_SUCCESS,
})

export const getDesktopActivityFailure = error => ({
  error,
  type: GET_DESKTOP_ACTIVITY_FAILURE,
})

export const getDesktopEvents = (contactId, isRootRecording) => {
  return async dispatch => {
    dispatch(getDesktopEventsRequested())
    try {
      const desktopEvents = await API.getDesktopEvents(contactId, isRootRecording)
      dispatch(getDesktopEventsSuccess(desktopEvents))
    } catch (error) {
      dispatch(getDesktopEventsFailure(error))
    }
  }
}

export const getDesktopEventsRequested = () => ({
  type: GET_DESKTOP_EVENTS_REQUESTED,
})

export const getDesktopEventsSuccess = data => ({
  data,
  type: GET_DESKTOP_EVENTS_SUCCESS,
})

export const getDesktopEventsFailure = error => ({
  error,
  type: GET_DESKTOP_EVENTS_FAILURE,
})
